import { defineMessages } from "react-intl";
import { ArticleType } from "@shared/url";

export const articleTypes = {
  nav: defineMessages<ArticleType | "sold">({
    [ArticleType.RENTAL]: { id: "generic.article-types.nav.accommodation-rental", defaultMessage: "Biens à louer" },
    [ArticleType.SALE]: { id: "generic.article-types.nav.accommodation-sale", defaultMessage: "Biens en vente" },
    sold: { id: "generic.article-types.nav.accommodation-sold", defaultMessage: "Biens vendus" }
  }),
  page: defineMessages<ArticleType | "sold">({
    [ArticleType.RENTAL]: { id: "generic.article-types.page.accommodation-rental", defaultMessage: "Maisons de vacances" },
    [ArticleType.SALE]: { id: "generic.article-types.page.accommodation-sale", defaultMessage: "Nos biens à vendre" },
    sold: { id: "generic.article-types.page.accommodation-sold", defaultMessage: "Nos biens vendus" }
  })
};

export const pages = defineMessages({
  sales: { id: "nav.sales", defaultMessage: "Vente" },
  promos: { id: "nav.sales-promos", defaultMessage: "Promotions" },
  plots: { id: "nav.sales-promos-plots", defaultMessage: "Terrains en vente" },
  rentals: { id: "nav.rentals", defaultMessage: "Location" },
  renovation: { id: "nav.renovation", defaultMessage: "Rénovation" },
  makeovers: { id: "nav.makeovers", defaultMessage: "Gallerie de projets" },
  services: { id: "nav.services", defaultMessage: "Services" },
  agency: { id: "nav.agency", defaultMessage: "L'agence" },
  news: { id: "nav.news", defaultMessage: "Actualités" },
  contact: { id: "nav.contact", defaultMessage: "Contact" },
  withUs: { id: "nav.with-us", defaultMessage: "Vendre avec nous" },
  estimate: { id: "nav.estimate", defaultMessage: "Estimer son bien" }
});

export const common = defineMessages({
  and: { id: "generic.common.and", defaultMessage: "et" },
  ourProperties: { id: "generic.common.properties", defaultMessage: "Nos biens" },
  relatedTitle: { id: "generic.common.related-properties-title", defaultMessage: "Nous pensons que ces biens peuvent également vous intéresser" },
  countedRooms: { id: "generic.common.counted-rooms", defaultMessage: "{count, plural, =1 {# pièce} other {# pièces}}" },
  countedBedrooms: { id: "generic.common.counted-bedrooms", defaultMessage: "{count, plural, =1 {# chambre} other {# chambres}}" },
  countedBathrooms: { id: "generic.common.counted-bathrooms", defaultMessage: "{count, plural, =1 {# salle de bain} other {# salles de bains}}" },
  countedGuests: { id: "generic.common.counted-guests", defaultMessage: "{count, plural, =1 {# personne} other {# personnes}}" },
  limitedGuests: { id: "generic.common.limited-guests", defaultMessage: "{format, select, single {{count} personne} max {{max}+ personnes} other {{count} personnes}}" }
});

export const pricing = defineMessages({
  unit: { id: "generic.prices.unit", defaultMessage: "Prix unitaire" },
  amount: { id: "generic.prices.amount", defaultMessage: "Montant" },
  discount: { id: "generic.prices.discount", defaultMessage: "Réduction" },
  total: { id: "generic.prices.total", defaultMessage: "Total" },
  detailed: { id: "generic.prices.detailed", defaultMessage: "Détail du prix" },
  onDemand: { id: "generic.prices.on-demand", defaultMessage: "Prix sur demande" },
  onDemandShort: { id: "generic.prices.on-demand-short", defaultMessage: "Sur demande" },
  lowest: { id: "generic.prices.lowest", defaultMessage: "Dès {price} par {type, select, DAILY {nuit} other {semaine}}"},
  byNight: { id: "generic.prices.by-night", defaultMessage: "{price} par nuitée" },
  byWeek: { id: "generic.prices.by-week", defaultMessage: "Dès {price} par semaine" },
  byMonth: { id: "generic.prices.by-month", defaultMessage: "{price} par mois" },
  down: { id: "generic.prices.down-payment", defaultMessage: "Acompte" },
  chargeLabel: { id: "generic.prices.charge-label", defaultMessage: "Frais de service" },
  charge: { id: "generic.prices.charge", defaultMessage: "{adaptive, select, true {jusqu'à } other {}}{amount}" },
  taxes: { id: "generic.prices.taxes", defaultMessage: "Taxes de séjour" }
});

export const booking = defineMessages({
  checkIn: { id: "generic.booking.check-in", defaultMessage: "Arrivée" },
  checkOut: { id: "generic.booking.check-out", defaultMessage: "Départ" },
  period: { id: "generic.booking.period", defaultMessage: "Période" },
  nights: { id: "generic.booking.nights", defaultMessage: "{count, plural, =1 {une nuit} other {# nuits}}" },
  reset: { id: "generic.booking.reset-period", defaultMessage: "Effacer les dates" }
});

export const actions = defineMessages({
  login: { id: "generic.actions.login", defaultMessage: "Se connecter" },
  logout: { id: "generic.actions.logout", defaultMessage: "Se déconnecter" },
  register: { id: "generic.actions.register", defaultMessage: "Je m'inscris" },
  refresh: { id: "generic.actions.refresh", defaultMessage: "Rafraîchir" },
  remove: { id: "generic.actions.remove", defaultMessage: "Supprimer" },
  cancel: { id: "generic.actions.cancel", defaultMessage: "Annuler" },
  continue: { id: "generic.actions.continue", defaultMessage: "Continuer" },
  back: { id: "generic.actions.back", defaultMessage: "Retour" },
  backHome: { id: "generic.actions.back-home", defaultMessage: "Retour à la page d'accueil" },
  send: { id: "generic.actions.send", defaultMessage: "Envoyer ma demande" },
  contact: { id: "generic.actions.contact", defaultMessage: "Prendre contact" },
  contactUs: { id: "generic.actions.contact-us", defaultMessage: "Contactez-nous" },
  more: { id: "generic.actions.more", defaultMessage: "En savoir plus" },
  book: { id: "generic.actions.book", defaultMessage: "Réserver" },
  bookHoliday: { id: "generic.actions.book-holiday", defaultMessage: "Réservez votre séjour" },
  close: { id: "generic.actions.close", defaultMessage: "Fermer" },
  validate: { id: "generic.actions.validate", defaultMessage: "Valider" },
  save: { id: "generic.actions.save", defaultMessage: "Enregistrer" },
  showMap: { id: "generic.actions.map-show", defaultMessage: "Afficher la carte" },
  showList: { id: "generic.actions.list-show", defaultMessage: "Voir la liste" },
  search: { id: "generic.actions.search", defaultMessage: "Rechercher" },
  reset: { id: "generic.actions.reset", defaultMessage: "Réinitialiser" }
});

export const form = defineMessages({
  other: { id: "generic.form.other", defaultMessage: "Autre" },
  firstName: { id: "generic.form.firstName", defaultMessage: "Prénom" },
  lastName: { id: "generic.form.lastName", defaultMessage: "Nom" },
  email: { id: "generic.form.email", defaultMessage: "E-mail" },
  phone: { id: "generic.form.phone", defaultMessage: "Téléphone" },
  address: { id: "generic.form.address", defaultMessage: "Adresse" },
  street: { id: "generic.form.street", defaultMessage: "Rue" },
  streetNumber: { id: "generic.form.streetNumber", defaultMessage: "N°" },
  streetComplement: { id: "generic.form.streetComplement", defaultMessage: "Adresse complémentaire" },
  zip: { id: "generic.form.zip", defaultMessage: "NPA" },
  city: { id: "generic.form.city", defaultMessage: "Ville" },
  country: { id: "generic.form.country", defaultMessage: "Pays" },
  countryPlaceholder: { id: "generic.form.country-placeholder", defaultMessage: "Sélectionnez un pays" },
  msg: { id: "generic.form.msg", defaultMessage: "Message" },
  msgPlaceholder: { id: "generic.form.msg-placeholder", defaultMessage: "Dites-nous comment nous pouvons vous aider." },
  datePlaceholder: { id: "generic.form.date-placeholder", defaultMessage: "Ajouter des dates" },
  guests: { id: "generic.form.guests", defaultMessage: "Personnes" },
  guestsPlaceholder: { id: "generic.form.guests-placeholder", defaultMessage: "Ajouter le nombre de personnes" },
  objectType: { id: "generic.form.object-type", defaultMessage: "Type de bien" },
  objectTypePlaceholder: { id: "generic.form.object-type-placeholder", defaultMessage: "Sélectionnez un type de bien" },
  emptyError: { id: "generic.form.errors.empty", defaultMessage: "Cette information est requise" },
  emailError: { id: "generic.form.errors.email", defaultMessage: "Cet e-mail n'est pas valide" },
  phoneError: { id: "generic.form.errors.phone", defaultMessage: "Ce numéro n'est pas valide. Respectez le format international (+41 xx xxx xx xx)" },
  minError: { id: "generic.form.errors.min", defaultMessage: "Doit contenir au moins {min} caractères" },
  sent: { id: "generic.form.sent", defaultMessage: "Votre message a été envoyé avec succès" },
  failed: { id: "generic.form.failed", defaultMessage: "Une erreur est survenue à l'envoi" },
  legal: { id: "generic.form.legal", defaultMessage: "J'accepte que EV Real Estate Service SARL traite mes données personnelles pour répondre à ma demande, conformément à la <link>politique de confidentialité</link>." }
});

export const article = defineMessages({
  published: { id: "generic.article.published", defaultMessage: "Publié le {date}" },
  type: { id: "generic.article.object-type", defaultMessage: "Type" },
  floor: { id: "generic.article.floor", defaultMessage: "Étage" },
  surface: { id: "generic.article.surface", defaultMessage: "Surface habitable" },
  plotSurface: { id: "generic.article.plot-surface", defaultMessage: "Surface du terrain" },
  rooms: { id: "generic.article.rooms", defaultMessage: "Pièces" },
  roomRooms: { id: "generic.article.rooms-whole", defaultMessage: "Ensemble" },
  bedrooms: { id: "generic.article.bedrooms", defaultMessage: "Chambres" },
  bathrooms: { id: "generic.article.bathrooms", defaultMessage: "Salles de bains" },
  equipment: { id: "generic.article.equipment", defaultMessage: "Équipements" },
  cityCenter: { id: "generic.article.features.city-center", defaultMessage: "Proche du centre" },
  shoppingArea: { id: "generic.article.features.shopping-area", defaultMessage: "Sur rue commerçante" },
  skiArea: { id: "generic.article.features.ski-area", defaultMessage: "À proximité des remontées" },
  busStop: { id: "generic.article.features.bus-stop", defaultMessage: "Proche des transports en commun" },
  clearView: { id: "generic.article.features.clear-view", defaultMessage: "Vue dégagée" },
  parking: { id: "generic.article.features.parking", defaultMessage: "Parking" },
  heating: { id: "generic.article.features.heating", defaultMessage: "Chauffage" },
  lift: { id: "generic.article.features.lift", defaultMessage: "Ascenseur" },
  balcony: { id: "generic.article.features.balcony", defaultMessage: "Balcon" },
  terrace: { id: "generic.article.features.terrace", defaultMessage: "Terrasse" },
  pool: { id: "generic.article.features.pool", defaultMessage: "Piscine" },
  sauna: { id: "generic.article.features.sauna", defaultMessage: "Sauna" },
  hotTub: { id: "generic.article.features.hot-tub", defaultMessage: "Bain à remous" },
  hammam: { id: "generic.article.features.hammam", defaultMessage: "Hammam" },
  fireplace: { id: "generic.article.features.fireplace", defaultMessage: "Cheminée" },
  dishwasher: { id: "generic.article.features.dishwasher", defaultMessage: "Lave-vaisselle" },
  washingMachine: { id: "generic.article.features.washing-machine", defaultMessage: "Lave-linge" },
  hairdryer: { id: "generic.article.features.hairdryer", defaultMessage: "Sèche-cheveux" },
  tv: { id: "generic.article.features.tv", defaultMessage: "TV" },
  wifi: { id: "generic.article.features.wifi", defaultMessage: "WIFI" },
  microwave: { id: "generic.article.features.microwave", defaultMessage: "Micro-onde" },
  oven: { id: "generic.article.features.oven", defaultMessage: "Four" },
  smoker: { id: "generic.article.features.smoker", defaultMessage: "Non-fumeur" },
  pet: { id: "generic.article.features.pet", defaultMessage: "Animaux admis" },
  disabledPerson: { id: "generic.article.features.disabled-person", defaultMessage: "Accès pour personnes à mobilité réduite" },
  new: { id: "generic.article.features.new", defaultMessage: "Neuf" },
  furnished: { id: "generic.article.features.furnished", defaultMessage: "Meublé" },
  secondaryHome: { id: "generic.article.features.secondary-home", defaultMessage: "Résidence secondaire" },
  forForeigners: { id: "generic.article.features.for-foreigners", defaultMessage: "Disponible aux non-résidants" },
  sport: { id: "generic.article.features.sport-facilities", defaultMessage: "Installations sportives" },
  smokeAlarm: { id: "generic.article.features.smoke-alarm", defaultMessage: "Détecteur de fumée" },
  carbonAlarm: { id: "generic.article.features.carbon-alarm", defaultMessage: "Détecteur de monoxyde de carbone" },
  raclette: { id: "generic.article.features.raclette-set", defaultMessage: "Fourneau à raclette" },
  fondue: { id: "generic.article.features.fondue-set", defaultMessage: "Service à fondue" },
  laundryRoom: { id: "generic.article.features.laundry-room", defaultMessage: "Buanderie" }
});
